/* tslint:disable */
/* eslint-disable */
/**
 * Twioku-API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {
    UserQuestionStatusSendOrderOneOf,
    instanceOfUserQuestionStatusSendOrderOneOf,
    UserQuestionStatusSendOrderOneOfFromJSON,
    UserQuestionStatusSendOrderOneOfFromJSONTyped,
    UserQuestionStatusSendOrderOneOfToJSON,
} from './UserQuestionStatusSendOrderOneOf';
import {
    UserQuestionStatusSendOrderOneOf1,
    instanceOfUserQuestionStatusSendOrderOneOf1,
    UserQuestionStatusSendOrderOneOf1FromJSON,
    UserQuestionStatusSendOrderOneOf1FromJSONTyped,
    UserQuestionStatusSendOrderOneOf1ToJSON,
} from './UserQuestionStatusSendOrderOneOf1';
import {
    UserQuestionStatusSendOrderOneOf2,
    instanceOfUserQuestionStatusSendOrderOneOf2,
    UserQuestionStatusSendOrderOneOf2FromJSON,
    UserQuestionStatusSendOrderOneOf2FromJSONTyped,
    UserQuestionStatusSendOrderOneOf2ToJSON,
} from './UserQuestionStatusSendOrderOneOf2';

/**
 * @type UserQuestionStatusSendOrder
 * 
 * @export
 */
export type UserQuestionStatusSendOrder = UserQuestionStatusSendOrderOneOf | UserQuestionStatusSendOrderOneOf1 | UserQuestionStatusSendOrderOneOf2;

export function UserQuestionStatusSendOrderFromJSON(json: any): UserQuestionStatusSendOrder {
    return UserQuestionStatusSendOrderFromJSONTyped(json, false);
}

export function UserQuestionStatusSendOrderFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserQuestionStatusSendOrder {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return { ...UserQuestionStatusSendOrderOneOfFromJSONTyped(json, true), ...UserQuestionStatusSendOrderOneOf1FromJSONTyped(json, true), ...UserQuestionStatusSendOrderOneOf2FromJSONTyped(json, true) };
}

export function UserQuestionStatusSendOrderToJSON(value?: UserQuestionStatusSendOrder | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }

    if (instanceOfUserQuestionStatusSendOrderOneOf(value)) {
        return UserQuestionStatusSendOrderOneOfToJSON(value as UserQuestionStatusSendOrderOneOf);
    }
    if (instanceOfUserQuestionStatusSendOrderOneOf1(value)) {
        return UserQuestionStatusSendOrderOneOf1ToJSON(value as UserQuestionStatusSendOrderOneOf1);
    }
    if (instanceOfUserQuestionStatusSendOrderOneOf2(value)) {
        return UserQuestionStatusSendOrderOneOf2ToJSON(value as UserQuestionStatusSendOrderOneOf2);
    }

    return {};
}

